import { useRef } from 'react';
import { useMount, useUnmount } from 'ahooks';

export default function useMountedRef(initialValue: IInitialValue = false) {
  const mountedRef = useRef(initialValue);

  useMount(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
    }
  });

  useUnmount(() => {
    if (mountedRef.current) {
      mountedRef.current = false;
    }
  });

  return mountedRef;
}
